<template>
  <div class="scrolling-wrapper-flexbox">
    <template v-for="(doc, index) in documents">
      <div v-if="doc.canAccess" :key="index"
        class="carder bg-white d-flex lg:mx-0 border border-zt-dark-200 rounded sm:my-3 w-full xl:my-3 xl:mx-0 xs:mx-2 shadow-none"
        :class="index === 0 ? 'carder-first' : ''" @click="redirectTo(doc.to)">
        <div class="align-center d-flex image-left-menu mx-auto m-h-full p-0 w-1/6 pr-2">
          <div class="w-3/4 flex justify-end mx-auto">
            <zt-icon class="text-3xl text-zt-primary-200" :name="doc.image" />
          </div>
        </div>
        <div class="w-full d-flex cursor-pointer">
          <v-card-text class="justify-between align-center p-3" style="display:flex">
            <div>
              <div class="text-zt-lg text-zt-dark-500 font-bold font-medium">
                {{ doc.name }}
              </div>
              <div v-if="doc.id === 'documents' && !isEmptyDocuments" class="text-zt-dark-300 ">
                {{
                  $tc(
                    'message.inicioComponent.documentsAvailable',
                    getUnsignedTotalDocsLength
                  )
                }}
              </div>
              <div v-if="doc.id === 'licenses' &&
                  loadingAvailableDays == false &&
                  !hasVPI
                  " class="text-zt-dark-300">
                <div v-if="showDetails">
                  {{
                    $tc(
                      'message.inicioComponent.licensesAvailable',
                      availableDays
                    )
                  }}
                </div>
                <div v-else>
                  {{
                    $tc(
                      'message.inicioComponent.licensesRegistered',
                      availableDays
                    )
                  }}
                </div>
              </div>
              <div v-if="doc.id === 'upload'" class="text-zt-dark-300">
                {{ $tc('message.inicioComponent.upload') }}
              </div>
              <div v-if="doc.id === 'self-service'" class="text-zt-dark-300">
                {{ doc.subtitle }}
              </div>
              <div v-if="doc.id === 'documentsManagement'" class="text-zt-dark-300">
                {{ doc.subtitle }}
              </div>
            </div>
            <div>
              <zt-icon name="angle-right" class="text-zt-dark-500" />
            </div>
          </v-card-text>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Licenses from '../../../apiClient/Licenses'
import { mapActions, mapGetters, mapState } from 'vuex'
import { forEach, isEmpty, includes } from 'lodash'
import { useWindowResize } from '@sichern/ui-elements'
import trunc from '@/utils/trunc.js'
import i18n from '@/plugins/i18n'

export default {
  components: {},
  data() {
    return {
      documents: [
        {
          id: 'documents',
          name: this.$t('message.homeComponent.sections.documents_to_sign'),
          color: 'pinkPrimary',
          image: 'file-text-outline',
          subtitle: this.$t(
            'message.homeComponent.sections.subtitles.sub_documents_sing'
          ),
          to: 'documents',
          canAccess: false
        },
        {
          id: 'licenses',
          name: this.$t('message.homeComponent.sections.vacations_licenses'),
          color: 'buttonPrimaryOver',
          image: 'date-down-outline',
          subtitle: this.$t(
            'message.homeComponent.sections.subtitles.sub_vacations_licences'
          ),
          to: 'licenses',
          canAccess: false
        },
        {
          id: 'documentsManagement',
          name: this.$t('message.homeComponent.sections.documentsManagement'),
          color: 'aquaPrimary',
          image: 'inbox-outline',
          subtitle: this.$t(
            'message.homeComponent.sections.subtitles.documentsManagement'
          ),
          to: 'documentsManagement',
          canAccess: false
        },
        {
          id: 'self-service',
          name: this.$t('message.homeComponent.sections.self_service'),
          subtitle: this.$t(
            'message.homeComponent.sections.subtitles.sub_self_service'
          ),
          color: 'aquaPrimary',
          image: 'user-outlined',
          to: 'selfService',
          canAccess: false
        }
      ],
      unsignedDocs: 0,
      loadingUnsigned: false,
      loadingAvailableDays: false,
      availableDays: 0,
      documentsAccess: false,
      uploadFileAccess: false,
      licensesAccess: false,
      selfServiceUser: false,
      userCanApproveLicenses: false,
      licenses: Licenses,
      windowResize: useWindowResize(this),
      showDetails: null
    }
  },

  created() {
    window.scrollTo(0, 0)
    this.licenses = new Licenses()
    this.setActions()
    this.getLicences()
    if (this.isInboxDocumentActivated) {
      this.setInitialDocumentsInbox()
    } else {
      this.setInitialDocuments()
    }
    this.setLocale()
  },

  methods: {
    ...mapActions(['setLocale']),
    ...mapActions('documents', ['setInitialDocuments', 'setInitialDocumentsInbox']),
    async getLicences() {
      try {
        if (this.licensesAccess && !this.hasVPI) {
          this.loadingAvailableDays = true
          const getLicencesResponse = await this.licenses.getLicenseTypes()
          const {
            data: { data }
          } = getLicencesResponse
          let vacationId = ''
          forEach(data, type => {
            if (type.isVacation) {
              vacationId = type.id
              return false
            }
          })
          const { available, show_details } = (await this.licenses.getBalanceByType(vacationId)).data.results.data[0];
          this.availableDays = trunc(available);
          this.showDetails = show_details;
          this.loadingAvailableDays = false
        }
      } catch (error) {
        // console.log(error)
      }
    },

    setActions() {
      const profiles = this.user.perfiles
      let isHr = false
      let isApprover = false
      profiles.forEach(profile => {
        if (profile.id_perfil_tipo === 2 || profile.id_perfil_tipo === 7) {
          isHr = true
        }
        if (profile.id_perfil_tipo === 5) {
          isApprover = true
        }
      })

      let hasId77 = false
      let hasId205 = false

      forEach(this.actions, action => {
        if (action.id == 27) {
          this.documentsAccess = true
          this.documents[0].canAccess = true
        }
        if (action.id == 72 && this.user.estado_empresa != 3) {
          this.licensesAccess = true
          this.documents[1].canAccess = true
        }
        if (action.id == 77 && this.user.estado_empresa != 3) {
          this.uploadFileAccess = true
          this.documents[2].canAccess = true
          hasId77 = true
        }
        if (action.id == 71) {
          this.userCanApproveLicenses = true
          this.documents[1].canAccess = true
          this.documents[1].to = 'licensesManager'
        }
        if (includes(['201', '202', '203', '204'], action.id)) {
          this.selfServiceUser = true
          this.documents[3].canAccess = true
        }
        if (action.id == 205) {
          this.documents[2].to = 'certificates'
          this.documents[2].canAccess = true
          hasId205 = true
        }
      })
      if (hasId77 && hasId205) {
        this.documents[2].to = 'documentsManagement'
        this.documents[2].canAccess = true
      }
    },
    redirectTo(to) {
      this.$router.push({ name: to })
    }
  },
  computed: {
    ...mapState(['actions', 'user']),
    ...mapState('documents', ['unsigned', 'signed']),
    ...mapGetters('documents', ['getUnsignedTotalDocsLength']),
    isEmptyDocuments() {
      const actions = this.$store.state.actions
      if (actions.some(action => action.id === '304')) {
        return isEmpty(this.$store.state.documents.unsigned) && isEmpty(this.$store.state.documents.signed)
      }
      return isEmpty(this.$store.state.documents.documents)
    },
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
    locale() {
      return this.$store.getters.getLocale
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    }
  },
  watch: {
    '$store.state.actions'() {
      this.setActions()
    },

    locale() {
      i18n.locale = this.locale
        ; (this.documents[1].name = this.$t(
          'message.homeComponent.sections.vacations_licenses'
        )),
          this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './home.scss';
</style>
